import { theme } from './theme';

/**
 * Cor de identidade de cada solução — fonte única usada pelos cards da home,
 * pelas páginas de produto e pela logomarca do cabeçalho.
 */
export const solutionColors = {
  agentes: theme.colors.primary.synapse,
  'modelos-ia': theme.colors.primary.accent,
  consultoria: theme.colors.primary.darkBlue,
} as const;

export type SolutionId = keyof typeof solutionColors;

/** Rota de cada solução, para resolver a cor a partir da URL atual. */
export const solutionPaths: Record<string, SolutionId> = {
  '/agentes-inteligentes': 'agentes',
  '/modelos-ia': 'modelos-ia',
  '/consultoria-dados': 'consultoria',
};

/**
 * Cor da solução correspondente à rota. Fora das páginas de solução
 * (home, contato, 404) devolve o azul claro da marca.
 */
export const getSolutionColorByPath = (pathname: string): string => {
  const id = solutionPaths[pathname];
  return id ? solutionColors[id] : theme.colors.primary.synapse;
};
